module.exports = __webpack_public_path__ + "media/images/right_show_sidebar/plus-1-66a727615380e5de7d9360c93a311160.svg";